import { memo, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';

// project imports
import { useAuth } from 'modules/auth/hooks/useAuth';
import menuItem from 'shared/components/menu-items';
import { canAccessPoSoTracking } from 'shared/utils/poSoTrackingAccess';
import NavGroup from './NavGroup';
import useConfig from 'shared/hooks/useConfig';

import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';

// types
import { NavItemType } from 'types';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const theme = useTheme();
    const { layout } = useConfig();
    const { isAdmin, isOwner, currentUser } = useAuth();
    const poSoTrackingAllowed = canAccessPoSoTracking(currentUser?.sub);

    const visibleMenuItems = useMemo(
        () =>
            menuItem.items
                .filter((item) => item.id !== 'dashboard' || isAdmin || isOwner)
                .map((item) =>
                    item.id === 'ordering' && (!isOwner || !poSoTrackingAllowed)
                        ? {
                              ...item,
                              children: item.children?.filter((child) => child.id !== 'po-so-tracking')
                          }
                        : item
                ),
        [isAdmin, isOwner, poSoTrackingAllowed]
    );

    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    // last menu-item to show in horizontal menu bar
    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    let lastItemIndex = visibleMenuItems.length - 1;
    let remItems: NavItemType[] = [];
    let lastItemId: string;

    if (lastItem && lastItem < visibleMenuItems.length) {
        lastItemId = visibleMenuItems[lastItem - 1].id!;
        lastItemIndex = lastItem - 1;
        remItems = visibleMenuItems.slice(lastItem - 1, visibleMenuItems.length).map((item) => ({
            title: item.title,
            elements: item.children
        }));
    }

    const navItems = visibleMenuItems.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} lastItem={lastItem!} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
